import { Action, Dispatch } from "redux";
import api from "../../api";
export interface AddLoanCarAction extends Action {
    type: "ADD_LOAN_CAR";
    car: LoanCar;
    departmentId: string
}
export interface AddLoanCarsAction extends Action {
    type: "ADD_LOAN_CARS";
    cars: LoanCar[];
    departmentId: string
}
export interface DelelteLoanCarAction extends Action {
    type: "DELETE_LOAN_CAR";
    id: string;
    departmentId: string
}
export interface AddDamageAction extends Action {
    type: "ADD_DAMAGE";
    damage: CarDamage;
    carId: string;
    departmentId: string
}
export interface RemoveDamageFromLoanCarAction extends Action {
    type: "REMOVE_DAMAGE_FROM_LOAN_CAR";
    id: string;
    carId: string;
    departmentId: string
}
export const addLoanCar = (departmentId: string, regnumber: string) =>async (dispatch: Dispatch) => {
    
    const result = await api.DepartmentLoanCarApi.add(departmentId, regnumber);
    dispatch({
        type: "ADD_LOAN_CAR",
        car: result,
        departmentId: departmentId
    } as AddLoanCarAction);
};

export const removeLoanCar = (departmentId: string, loanCar: string) =>async (dispatch: Dispatch) => {
    
    await api.DepartmentLoanCarApi.delete(loanCar);
    dispatch({
        type: "DELETE_LOAN_CAR",
        id: loanCar,
        departmentId: departmentId
    } as DelelteLoanCarAction);
};

export const getLoanCars = (departmentId: string) =>async (dispatch: Dispatch) => {
    const result = await api.DepartmentLoanCarApi.get(departmentId,);
    dispatch({
        type: "ADD_LOAN_CARS",
        cars: result,
        departmentId: departmentId
    } as AddLoanCarsAction);
};
export const removeDamage = (departmentId: string, carId: string, damageId: string) =>async (dispatch: Dispatch) => {
    
    await api.DepartmentLoanCarApi.deleteDamage(carId, damageId);
    dispatch({
        type: "REMOVE_DAMAGE_FROM_LOAN_CAR",
        id: damageId,
        departmentId: departmentId,
        carId: carId
    } as RemoveDamageFromLoanCarAction);
};
export const addDamage = (departmentId: string, carId: string, data: CarDamage) =>async (dispatch: Dispatch) => {
    
    const result = await api.DepartmentLoanCarApi.addDamage(departmentId,carId, data);
    dispatch({
        type: "ADD_DAMAGE",
        damage: result,
        departmentId: departmentId,
        carId: carId
    } as AddDamageAction);
};